import { FileAddOutlined, QuestionOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { Card, Typography } from "antd";
import { CSSProperties } from "react";
import { useNavigate } from "react-router-dom";

const sharedIcons: CSSProperties = {
    fontSize: '50px',
    border: '6px solid',
    padding: '10px',
    borderRadius: '50px',
    color: '#0000A4'
}

const sharedCard: CSSProperties = {
    border: '3px solid',
    borderColor: '#0000A4',
    width: '100%',
    height: '300px',
    display: 'flex',
    padding: '20px',
    boxShadow: '0px 4px 4px 0px #00000040',
    cursor: 'pointer'
}

const sharedTitles: CSSProperties = {
    color: '#0000A4',
    fontSize: '22px',
    fontWeight: 'bolder',
    textAlign: 'center',
    marginBottom: '15px'
}

const sharedSubtitles: CSSProperties = {
    color: '#000000A6',
    fontSize: '14px'
}

export default function ControlPanelPage () {

    const navigate = useNavigate()

    const redirectRoute = () => {
        navigate(`/`)
    }

    const redirectFinancialLines = () => {
        navigate(`/finance/financialLines`)
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', width: '100%', height: '50vh', background: 'white', justifyContent: 'center', borderRadius: '10px', margin: '16px 0px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 33.3%)', width: '75%', columnGap: '16px' }}>

                <Card onClick={() => redirectRoute()} className="anim-pop-up-03" style={sharedCard}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0px 0px 10px 0px' }}>
                        <UnorderedListOutlined style={sharedIcons} />
                    </div>
                    <Typography style={sharedTitles}>Seleção de empresa</Typography>
                    <Typography style={sharedSubtitles}>Aqui te leva de volta para a tela de seleção de empresa</Typography>
                </Card>

                <Card style={{ ...sharedCard, filter: 'opacity(0.2)', cursor: 'default' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0px 0px 10px 0px' }}>
                        <QuestionOutlined style={sharedIcons} />
                    </div>
                    <Typography style={sharedTitles}>Área POP</Typography>
                    <Typography style={sharedSubtitles}>Área para realizar solicitações ao time de produto</Typography>
                </Card>

                <Card onClick={() => redirectFinancialLines()} className="anim-pop-up-03" style={sharedCard}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0px 0px 10px 0px' }}>
                        <FileAddOutlined style={sharedIcons} />
                    </div>
                    <Typography style={sharedTitles}>Linhas de Financiamento</Typography>
                    <Typography style={sharedSubtitles}>Área para realizar o controle das linhas de financiamentos do aplicativo</Typography>
                </Card>

            </div>
        </div>
    )
}

